import { useParticipantIds, DailyAudio } from '@daily-co/daily-react'

export function RemoteAudio() {
  // render hidden <audio> elements for all remote participants
  const ids = useParticipantIds({ filter: 'remote' }) || []
  return ids.map((id) => <DailyAudio key={id} />)
}
